/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkLookupReleaseRequest
 */
export interface BulkLookupReleaseRequest {
    /**
     * Release id at source (e.g. discogs)
     * @type {string}
     * @memberof BulkLookupReleaseRequest
     */
    sourceId: string;
    /**
     * Source system
     * @type {string}
     * @memberof BulkLookupReleaseRequest
     */
    source: BulkLookupReleaseRequestSourceEnum;
    /**
     * Every recording in the selection. Each is reported back, linked or not.
     * @type {Array<string>}
     * @memberof BulkLookupReleaseRequest
     */
    recordingIds: Array<string>;
}


/**
 * @export
 */
export const BulkLookupReleaseRequestSourceEnum = {
    Discogs: 'discogs',
    Mb: 'MB',
    Spotify: 'spotify',
    Deezer: 'deezer',
    Ppl: 'ppl'
} as const;
export type BulkLookupReleaseRequestSourceEnum = typeof BulkLookupReleaseRequestSourceEnum[keyof typeof BulkLookupReleaseRequestSourceEnum];


/**
 * Check if a given object implements the BulkLookupReleaseRequest interface.
 */
export function instanceOfBulkLookupReleaseRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sourceId" in value;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "recordingIds" in value;

    return isInstance;
}

export function BulkLookupReleaseRequestFromJSON(json: any): BulkLookupReleaseRequest {
    return BulkLookupReleaseRequestFromJSONTyped(json, false);
}

export function BulkLookupReleaseRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkLookupReleaseRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sourceId': json['source_id'],
        'source': json['source'],
        'recordingIds': json['recording_ids'],
    };
}

export function BulkLookupReleaseRequestToJSON(value?: BulkLookupReleaseRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'source_id': value.sourceId,
        'source': value.source,
        'recording_ids': value.recordingIds,
    };
}

